import { Box } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { SongWaveform, AudioPlayerButton } from 'components';
import { Song } from 'services/store/songs/types';
import { SongType } from 'services/api/entities';
import { AnalyticsEventLocation } from 'services/analytics/entities';

type PropsType = {
  song: Song | null;
  isPlayIconEnlarged?: boolean;
};

const Player = ({ song, isPlayIconEnlarged }: PropsType) => {
  if (!song) {
    return null;
  }

  // Get the player location in order to send it to the analytics
  const getSongDetailsLocation =
    song.songType === SongType.AI_GENERATED
      ? AnalyticsEventLocation.AI_GENERATED_SONG_DETAILS
      : AnalyticsEventLocation.SONG_DETAILS;

  return (
    <Box mb={3} mt={2.6}>
      <Box display="flex" alignItems="center" width="100%">
        <Box>
          <AudioPlayerButton
            isPlayIconEnlarged={isPlayIconEnlarged}
            song={song}
            location={getSongDetailsLocation}
          />
        </Box>
        <Box
          sx={{ pl: isMobile ? 1.5 : 3, pt: 1 }}
          width={isMobile ? '85%' : '80%'}
        >
          <SongWaveform song={song} />
        </Box>
      </Box>
    </Box>
  );
};

export default Player;
